/* global window */

import axios from 'axios';
import qs from 'qs';
import store from '../reducers/store';

class FilterService {
  deleteFilter(key, user) {
    return axios({
      method: 'DELETE',
      url: process.env.API_URL + 'filters/' + key,
      headers: {
        Authorization: window.localStorage.getItem('access_token'),
        'X-Org': window.localStorage.getItem('organization_id'),
        'X-Refresh-Token': window.localStorage.getItem('refresh_token'),
        'X-Username': window.localStorage.getItem('username'),
      },
    }).then((response) => {
      // console.log('SUCCESS')
      return response.data.user;
    });
  }

  editZmailTracked(trackedPlayerList, user) {
    // console.log('filter', filter)
    // console.log(playerId)
    const filterId = user.filters.filter((f) => f.filterCategory.name === 'trackedProspect')[0].id;

    const filterArray = trackedPlayerList.map((player) => {
      return player.id;
    });

    const newFilter = {
      filterValues: { players: filterArray },
      creator: user.username,
      name: null,
      type: 'trackedProspect',
    };

    return axios({
      method: 'PATCH',
      url: process.env.API_URL + 'filters/' + filterId,
      data: newFilter,
      headers: {
        Authorization: window.localStorage.getItem('access_token'),
        'X-Org': window.localStorage.getItem('organization_id'),
        'X-Refresh-Token': window.localStorage.getItem('refresh_token'),
        'X-Username': window.localStorage.getItem('username'),
      },
    }).then((response) => {
      return response.data.data;
    });
  }

  editFilter(filter) {
    const filterValues = {};

    filterValues.position = this._generatePositionList(filter.position || []);
    filterValues.years = this._generateYearList(filter.year || []);
    filterValues.offerCollege = this._generateOfferCollegeList(filter.offer || {});
    filterValues.offerConference = this._generateOfferConferenceList(filter.offer || {});
    filterValues.locationCounty = this._generateLocationCountyList(filter.county || {});
    filterValues.locationState = this._generateLocationStateList(filter.county || {});
    filterValues.status = this._generateStatusList(filter.status || []);

    if (filter.type === 'poi') {
      filterValues.rating = [0, filter.maxScore];
    } else if (filter.type === 'ratingBump') {
      filterValues.rating = [filter.range[0], filter.range[1]];
    }

    const newFilter = {
      filterValues: filterValues,
      creator: filter.user.username,
      name: null,
      type: filter.type,
    };

    return axios({
      method: 'PATCH',
      url: process.env.API_URL + 'filters/' + filter.key,
      data: newFilter,
      headers: {
        Authorization: window.localStorage.getItem('access_token'),
        'X-Org': window.localStorage.getItem('organization_id'),
        'X-Refresh-Token': window.localStorage.getItem('refresh_token'),
        'X-Username': window.localStorage.getItem('username'),
      },
    }).then((response) => {
      return response.data.user;
    });
  }

  createPOIFilter(filter) {
    const filterValues = {};

    filterValues.position = this._generatePositionList(filter.position);
    filterValues.years = this._generateYearList(filter.year);
    filterValues.offerCollege = this._generateOfferCollegeList(filter.offer);
    filterValues.offerConference = this._generateOfferConferenceList(filter.offer);
    filterValues.locationCounty = this._generateLocationCountyList(filter.county);
    filterValues.locationState = this._generateLocationStateList(filter.county);
    filterValues.rating = [0, filter.maxScore];

    const newFilter = {
      filterValues: filterValues,
      creator: filter.user.username,
      name: null,
      type: filter.type,
    };

    return axios({
      method: 'POST',
      url: process.env.API_URL + 'filters/',
      data: newFilter,
      headers: {
        Authorization: window.localStorage.getItem('access_token'),
        'X-Org': window.localStorage.getItem('organization_id'),
        'X-Refresh-Token': window.localStorage.getItem('refresh_token'),
        'X-Username': window.localStorage.getItem('username'),
      },
    }).then((response) => {
      return response.data.user;
    });
  }

  createTrackedFilter(filter) {
    const filterValues = {};

    filterValues.position = this._generatePositionList(filter.position);
    filterValues.years = this._generateYearList(filter.year);
    filterValues.locationCounty = this._generateLocationCountyList(filter.county);
    filterValues.locationState = this._generateLocationStateList(filter.county);
    filterValues.status = this._generateStatusList(filter.status);

    const newFilter = {
      filterValues: filterValues,
      creator: filter.user.username,
      name: null,
      type: filter.type,
    };

    return axios({
      method: 'POST',
      url: process.env.API_URL + 'filters/',
      data: newFilter,
      headers: {
        Authorization: window.localStorage.getItem('access_token'),
        'X-Org': window.localStorage.getItem('organization_id'),
        'X-Refresh-Token': window.localStorage.getItem('refresh_token'),
        'X-Username': window.localStorage.getItem('username'),
      },
    }).then((response) => {
      return response.data.user;
    });
  }

  createNewProspectFilter(filter) {
    const filterValues = {};
    filterValues.position = this._generatePositionList(filter.position);
    filterValues.years = this._generateYearList(filter.year);
    filterValues.locationCounty = this._generateLocationCountyList(filter.county);
    filterValues.locationState = this._generateLocationStateList(filter.county);

    const newFilter = {
      filterValues: filterValues,
      creator: filter.user.username,
      name: null,
      type: filter.type,
    };

    return axios({
      method: 'POST',
      url: process.env.API_URL + 'filters/',
      data: newFilter,
      headers: {
        Authorization: window.localStorage.getItem('access_token'),
        'X-Org': window.localStorage.getItem('organization_id'),
        'X-Refresh-Token': window.localStorage.getItem('refresh_token'),
        'X-Username': window.localStorage.getItem('username'),
      },
    }).then((response) => {
      // console.log('SUCCESS')
      return response.data.user;
    });
  }

  createRatingBumpFilter(filter) {
    const filterValues = {};

    filterValues.rating = [filter.range[0], filter.range[1]];
    filterValues.position = this._generatePositionList(filter.position);
    filterValues.years = this._generateYearList(filter.year);
    filterValues.locationCounty = this._generateLocationCountyList(filter.county);
    filterValues.locationState = this._generateLocationStateList(filter.county);

    const newFilter = {
      filterValues: filterValues,
      creator: filter.user.username,
      name: null,
      type: filter.type,
    };

    return axios({
      method: 'POST',
      url: process.env.API_URL + 'filters/',
      data: newFilter,
      headers: {
        Authorization: window.localStorage.getItem('access_token'),
        'X-Org': window.localStorage.getItem('organization_id'),
        'X-Refresh-Token': window.localStorage.getItem('refresh_token'),
        'X-Username': window.localStorage.getItem('username'),
      },
    }).then((response) => {
      return response.data.user;
    });
  }

  _generateStatusList = (statusList) => {
    if (statusList.length === 0 || statusList[0] === 'All') {
      return null;
    }

    const statusGuids = [];
    const statuses = store.getState().main.statuses;

    for (const status of statusList) {
      const index = statuses.findIndex((dbStatus) => {
        return dbStatus.name === status;
      });

      if (index === -1) {
        continue;
      }

      statusGuids.push(statuses[index].id);
    }

    return statusGuids;
  };

  _generateYearList = (yearList) => {
    if (yearList.length === 0 || yearList[0] === 'All') {
      return null;
    }

    return yearList.map((year) => {
      return year.includes('TR') ? year : parseInt(year);
    });
  };

  _generatePositionList = (positionList) => {
    if (positionList.length === 0 || positionList[0] === 'All') {
      return null;
    }
    const positionGuids = [];
    const positions = store.getState().main.positions;

    for (const position of positionList) {
      const index = positions.findIndex((dbPosition) => {
        return dbPosition.name === position;
      });

      if (index === -1) {
        continue;
      }

      positionGuids.push(positions[index].id);
    }

    return positionGuids;
  };

  _generateOfferCollegeList = (offerObj) => {
    const conferences = Object.keys(offerObj);

    let schoolList = [];

    const dbConferences = store.getState().main.conferences;

    for (const conference of conferences) {
      if (offerObj[conference][0] !== 'All') {
        schoolList = schoolList.concat([], offerObj[conference]);
      }
    }

    const offerGuids = [];

    for (const school of schoolList) {
      for (const dbConference of dbConferences) {
        for (const dbSchool of dbConference.colleges) {
          if (dbSchool.name === school) {
            offerGuids.push(dbSchool.college_sport_id);

            break;
          }
        }
      }
    }

    return offerGuids;
  };

  _generateLocationCountyList = (locationObj) => {
    const states = Object.keys(locationObj);
    let countyList = [];

    for (const state of states) {
      if (locationObj[state][0] !== 'All') {
        const countyObjects = locationObj[state].map((county) => {
          return { state: state, county: county };
        });

        countyList = countyList.concat([], countyObjects);
      }
    }

    const countyGuids = [];

    for (const county of countyList) {
      countyGuids.push(this.extractCounty(county));
    }

    return countyGuids;
  };

  extractCounty = (county) => {
    const dbStates = store.getState().main.states;

    for (const dbState of dbStates) {
      if (county.state == dbState.name) {
        for (const dbCounty of dbState.counties) {
          if (dbCounty.name === county.county) {
            return dbCounty.id;
          }
        }
      }
    }
  };

  _generateLocationStateList = (locationObj) => {
    const states = Object.keys(locationObj);
    const dbStates = store.getState().main.states;
    let stateList = [];

    for (const state of states) {
      if (locationObj[state][0] === 'All') {
        stateList = stateList.concat([], state);
      }
    }

    const stateGuids = [];

    for (const state of stateList) {
      const index = dbStates.findIndex((dbState) => {
        return dbState.name === state;
      });

      if (index === -1) {
        continue;
      }
      stateGuids.push(dbStates[index].id);
    }
    return stateGuids;
  };

  _generateOfferConferenceList = (offerObj) => {
    const conferences = Object.keys(offerObj);
    const dbConferences = store.getState().main.conferences;

    let conferenceList = [];

    for (const conference of conferences) {
      if (offerObj[conference][0] === 'All') {
        conferenceList = conferenceList.concat([], conference);
      }
    }

    const conferenceGuids = [];

    for (const conference of conferenceList) {
      const index = dbConferences.findIndex((dbConference) => {
        return dbConference.name === conference;
      });

      if (index === -1) {
        continue;
      }

      conferenceGuids.push(dbConferences[index].id);
    }

    return conferenceGuids;
  };
}

export default new FilterService();



// WEBPACK FOOTER //
// ./src/services/filterService.js